import React from 'react'
import Table from '@common/Table'
import getColumns from './columns'

export default ({ store }) => (
  <Table
    style={{ marginTop: 20 }}
    store={store}
    columns={getColumns(store)}
    rowKey="row_id"
  />
)
